import { differenceInDays, addDays } from 'date-fns';

export function getDate(dateString, isReverse = false, onlyMonth = false, onlyMMYY = false) {
	if (!dateString) {
		return 'Invalid Date';
	}

	const date = new Date(dateString);
	if (isNaN(date.getTime())) {
		return 'Invalid Date';
	}

	const year = date.getUTCFullYear();
	const month = String(date.getUTCMonth() + 1).padStart(2, '0');
	const day = String(date.getUTCDate()).padStart(2, '0');

	// const year = date.getFullYear();
	// const month = String(date.getMonth() + 1).padStart(2, '0');
	// const day = String(date.getDate()).padStart(2, '0');

	if (onlyMMYY) {
		return `${month}/${String(year).slice(-2)}`;
	}

	if (isReverse && !onlyMonth) {
		return `${year}-${month}-${day}`;
	}

	if ((onlyMonth && isReverse) || onlyMonth) {
		return `${month}/${year}`;
	}

	return `${day}/${month}/${year}`;
}

export function convertToISO(dateString) {
	const date = new Date(dateString);

	return date.toISOString();
}

export function getCurrentDate() {
	const today = new Date();
	const formattedDate = today.toISOString().split('T')[0];
	return formattedDate;
}

export const getExpiryText = (updatedAt) => {
	if (!updatedAt) return '';

	const expiryDate = new Date(updatedAt);
	expiryDate.setDate(expiryDate.getDate() + 7);

	const now = new Date();

	const diffMs = expiryDate - now;
	const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

	if (diffDays > 1) return `Expiring in ${diffDays} days`;
	if (diffDays === 1) return 'Expiring tomorrow';
	if (diffDays === 0) return 'Expiring today';
	return 'Expired';
};
